declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const gtmEvent = (eventName: string, parameters: Record<string, any> = {}) => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    console.warn('GTM not initialized or running server-side');
    return;
  }

  const eventData = {
    event: eventName,
    timestamp: new Date().toISOString(),
    ...parameters,
  };

  window.dataLayer.push(eventData);
  console.log('GTM Event:', eventData);
};

export const gtmEvents = {
  funnelEntry: (data: { page: string; flow?: string; userId?: string }) => {
    gtmEvent('ds_funnel_entry', {
      event_category: 'funnel',
      event_label: 'entry',
      page: data.page,
      flow: data.flow,
      user_id: data.userId,
    });
  },

  previewPageView: (data: { metaSiteId?: string; flow?: string; userId?: string; storeName?: string }) => {
    gtmEvent('preview_page_view', {
      event_category: 'preview',
      event_label: 'page_view',
      meta_site_id: data.metaSiteId,
      flow: data.flow,
      user_id: data.userId,
      store_name: data.storeName,
    });
  },

  checkoutClick: (data: { metaSiteId?: string; flow?: string; userId?: string }) => {
    gtmEvent('ds_funnel_checkout_click', {
      event_category: 'funnel',
      event_label: 'checkout_click',
      meta_site_id: data.metaSiteId,
      flow: data.flow,
      user_id: data.userId,
    });
  },
};
